/**
 * Memory Admin Cost Projections Tab
 *
 * Shows cost estimation and what-if analysis for memory configurations.
 */
import { useState } from 'react'
import { Card, Button } from '@personic/shared'
import { useMemoryAdminCostEstimate } from '../../../hooks/useMemoryAdmin'

export function MemoryAdminCosts() {
  const [episodesPerMonth, setEpisodesPerMonth] = useState(100)
  const { data: projection, isLoading, refetch } = useMemoryAdminCostEstimate(episodesPerMonth)

  return (
    <div className="space-y-6">
      <Card className="p-6 bg-neutral-900/50 border-neutral-800">
        <h3 className="text-lg font-semibold text-white mb-4">Cost Projector</h3>

        <div className="flex items-center gap-4 mb-6">
          <label className="text-sm text-neutral-400">Episodes/month:</label>
          <input
            type="number"
            value={episodesPerMonth}
            onChange={(e) => setEpisodesPerMonth(parseInt(e.target.value) || 100)}
            className="w-32 px-3 py-1.5 bg-neutral-800 border border-neutral-700 rounded text-white text-sm"
            min={1}
            max={10000}
          />
          <Button variant="outline" onClick={() => refetch()} className="border-neutral-600 text-sm">
            Calculate
          </Button>
        </div>

        {isLoading ? (
          <div className="animate-pulse h-24" />
        ) : projection ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div>
              <p className="text-xs text-neutral-500">Storage</p>
              <p className="text-lg font-bold text-white">{projection.storage_mb?.toFixed(1)} MB</p>
            </div>
            <div>
              <p className="text-xs text-neutral-500">Embeddings/mo</p>
              <p className="text-lg font-bold text-white">{projection.embedding_count}</p>
            </div>
            <div>
              <p className="text-xs text-neutral-500">Embedding Cost</p>
              <p className="text-lg font-bold text-white">${projection.embedding_cost_monthly?.toFixed(4)}</p>
            </div>
            <div>
              <p className="text-xs text-neutral-500">Total Cost/mo</p>
              <p className="text-lg font-bold text-purple-400">${projection.total_cost_monthly?.toFixed(4)}</p>
            </div>
          </div>
        ) : null}
      </Card>

      {projection?.breakdown && (
        <Card className="p-6 bg-neutral-900/50 border-neutral-800">
          <h3 className="text-lg font-semibold text-white mb-4">Breakdown</h3>
          <div className="grid grid-cols-2 gap-3">
            {Object.entries(projection.breakdown).map(([key, value]) => (
              <div key={key} className="flex justify-between py-1 border-b border-neutral-800">
                <span className="text-sm text-neutral-400">{key.replace(/_/g, ' ')}</span>
                <span className="text-sm text-white font-mono">{String(value)}</span>
              </div>
            ))}
          </div>
        </Card>
      )}
    </div>
  )
}
